<template>
  <div class="skinny-pagination">
    <el-button-group>
      <el-button
        size="small"
        :disabled="pageNo === 1"
        type="default"
        icon="el-icon-arrow-left"
        @click="$emit('on-change', pageNo - 1)"
      >
        上一页
      </el-button>
      <el-button
        size="small"
        type="default"
        :disabled="isEnd"
        icon="el-icon-arrow-right"
        @click="$emit('on-change', pageNo + 1)"
      >
        下一页
      </el-button>
    </el-button-group>
    <el-select
      v-if="showPageSize"
      class="skinny-pagination__page-size"
      size="small"
      :value="pageSize"
      @change="handlePageSizeChange"
    >
      <el-option v-for="size in pageSizeOptions" :key="size" :label="`${size} 条/页`" :value="size" />
    </el-select>
  </div>
</template>

<script>
/**
 * @file 只有上下翻页的分页器
 * <skinny-pagination
 *   :page-no="pageNo"
 *   :page-size.sync="pageSize"
 *   :is-end="pageNo * pageSize >= totalCount"
 *   show-page-size
 *   @on-change="onChange"
 *   @on-page-size-change="onPageSizeChange"
 * />
 * */

const PAGE_SIZE_OPTIONS = [10, 20, 30, 40, 50];

export default {
  name: 'skinny-pagination',
  props: {
    pageNo: {
      type: Number,
      default: 1
    },
    isEnd: {
      type: Boolean,
      default: true
    },
    pageSize: {
      type: Number,
      default: 10,
      validator: value => PAGE_SIZE_OPTIONS.includes(value)
    },
    showPageSize: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      pageSizeOptions: PAGE_SIZE_OPTIONS
    };
  },
  methods: {
    handlePageSizeChange(pageSize) {
      this.$emit('update:pageSize', pageSize);
      this.$emit('on-page-size-change', pageSize);
    }
  }
};
</script>

<style lang="scss" scoped>
.skinny-pagination {
  display: inline-flex;
  align-items: center;
  gap: 10px;
}

.skinny-pagination__page-size {
  width: 110px;
  margin-right: 8px;
}

.skinny-pagination__page-size {
  /deep/.el-input__inner {
    height: 33px !important;
    line-height: 33px !important;
  }
}
</style>
